import React from "react";
import {
    Form,
    Modal,
    Typography,
    Button,
    notification,
    DatePicker,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import CleaningTraceabilityApi from "../../Apis/CleaningTraceabilityApi";
import moment from 'moment';

const { Title } = Typography;
function AddNodeModel({ visible, onClose, NodeModeDatas }) {
    const [formAdd] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const getCurrentFormat = (timestamp) => {
        const date = new Date(timestamp);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
        return formattedDate;
    };
    const [Traceability, setTraceability] = React.useState([]);

    function handleDateChange(date, dateString) {
        CleaningTraceabilityApi.ListcleaningTraceabilityAssign().then((response) => {
            setTraceability(response.payloadDto.filter(item => item?.traceabilityType === NodeModeDatas && (getCurrentFormat(item?.cleaningTraceabilityAddDate) === getCurrentFormat(date))))

        })
            .catch((err) => {
                console.log(err);
            });
    }


    const handleSubmit = (data) => {
        let formData = JSON.stringify({
            cleaningTraceabilityType: NodeModeDatas,
            managerNote: data.managerNote,
            cleaningTraceabilityDTOList: Traceability.map((number) => ({ id: number?.cleaningTraceabilityItemDTO?.id })),
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });
        CleaningTraceabilityApi.PutCleaningTraceabilitycommon(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Updated</span>,
                    description: "Updated Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);

            })
            .catch((err) => {
                console.log(err);
                // Error Notification
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });


    }


    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };
    function disabledDate(current) {
        return current && current >= moment().endOf('day');
    }

    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Add Manager Note
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        {/* <ManagerNodeModel onCleaningfResponse={handleStorageResponse} NodeModeData={NodeModeDatas} /> */}

                        <Form.Item
                            name="OCROUBD"
                            label="Select Date"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Date ",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                disabledDate={disabledDate}
                                onChange={handleDateChange}
                                placeholder="Select Date"
                                className="form-control control-input"
                            />
                        </Form.Item>
                        < Form.Item
                            name="managerNote"
                            label="Manager Note "
                            className="text-lable pt-3"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Manager Note ",
                                },
                            ]}
                        >
                            <TextArea
                                className="form-control control-input p-3"
                                rows={3}
                                style={{ resize: "none" }}
                            ></TextArea>
                        </Form.Item>


                        {/* <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Save
                            </Button>

                        </div> */}
                        <div
                            className="d-flex justify-content-center pt-4"
                            style={{
                                padding: "16px 24px 0", // aligns with modal spacing
                            }}
                        >
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    width: "100%",
                                    maxWidth: "300px", // keeps it nicely centered and not overly wide
                                    height: 40,
                                    borderRadius: 6,
                                }}
                            >
                                Save
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddNodeModel;
